import styled from "styled-components";
import { Space, Button as AntButton } from "antd";
import { IMG_WHEEL_BG, RefreshOutlined } from "@assets";

export const RootContainer = styled.div`
	position: relative;
	height: 100vh;
	overflow-y: auto;
	/* background-color: #F2F1F0 !important */
`;

export const RefreshIcon = styled(RefreshOutlined)`
	font-size: 24px;
	color: #fff;
`;

export const HeadingBackground = styled.div`
  position: absolute;
  top: -80px;
  left: calc(50% - 311px);
  width: 622px;
  height: 361px;
  border-radius: 50%;
  background: linear-gradient(180deg, #FE8A02 0%, #FFEC63 100%);
  @media screen and (max-height: 670px) {
    border-radius: 60%;
		top: -120px;
	}
`

export const DailyWinnerListContainer = styled.div`
	margin: 291px 0 0 0;
	flex-direction: column;
	align-items: center;

	@media screen and (min-width: 400px) {
		margin: 298px 0 0 0;
	}
`;

export const EmptyTextWrapper = styled.div`
	height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const EmptyText = styled.div`
  color:  #DB7802;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const Title = styled.div`
  color:  #DB7802;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
	padding: 16px 0px 17px 0;
  width: 100%;
  max-width: 480px;
  margin: 0 auto auto 0;
  background-color: #FFF;
  border-radius: 16px 16px 0 0;
	@media (min-height: 735px) and (max-height: 745px) {
		margin-bottom: 0px;
	}
`;

export const Number = styled.div`
	width: 60px;
  height: 69px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #F2F1F0;

  color: #342309;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

	@media screen and (max-height: 670px) {
		font-size: 10px;
		line-height: 10px;
	}
`;

export const Bottom = styled(Space)`
	padding-top: 305px;
	padding-bottom: 16px;
	z-index: 99;
	background-color: ${(props) => props.theme.backgroundColor};
	position: fixed;
	width: 100%;
	max-width: 480px;
	gap: 16px !important;
	justify-content: center;

	.ant-space-item {
		flex: 1;

		:nth-child(1) {
			text-align: right;
			padding-inline-start: 16px;
		}

		:nth-child(2) {
			text-align: left;
			padding-inline-end: 16px;
		}
	}

	.ant-btn {
		width: 100%;
		background-color: #71207c !important;
	}

	@media screen and (max-width: 400px) {
		padding-top: 285px;
	}
`;



export const SpinnerBox = styled.div`
	width: 100%;
	position: sticky;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
`;

export const OuterBadge = styled.img.attrs({
  alt: "badge",
  id: "badge-img",
  src: IMG_WHEEL_BG,
})`
	position: absolute;
	width: 249px;
	height: 249px;
	border-radius: 50%;
	cursor: pointer;
	z-index: 200;
	top: 21px;
	margin-left: 0px;

	@media screen and (max-width: 350px) {
		width: 210px;
		height: 210px;
		margin-left: 0px;
		top: 42px;
	}
	@media screen and (max-height: 650px) {
		width: 190px;
		height: 190px;
		margin-left: -1px;
		top: 15px;
	}
`;

export const WheelContainer = styled.div`
	position: fixed;
	width: 100%;
	max-width: 480px;
	height: 293px;
	z-index: 800;
	display: flex;
	align-items: center;
	justify-content: center;

	> div {
		width: 220px;
		height: 220px;
		transform: rotate(-48deg);
	}

	img:not(#badge-img):not(#center) {
		display: none;
	}

	@media screen and (max-width: 350px) {
		> div {
			width: 190px;
			height: 190px;
		}
	}

	@media screen and (max-height: 650px) {
		> div {
			width: 170px;
			height: 170px;
		}
		height: 220px;
	}
`;

export const SpinButton = styled(AntButton)`
  padding: 10px 24px;
  position: absolute;
  top: 280px;
  left: calc(50% - 55px);
  border-radius: 12px;
  background: linear-gradient(270deg, #FFE83A 0%, #FF961B 100%);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  color: #13100F;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  svg{
    width: 24px;
    height: 24px;
  }

  @media screen and (max-height: 650px) {
    top: 220px;
  }
`

export const Container = styled.div`
	position: relative;
	z-index: 999;
	text-align: center;
	margin-top: 350px;

	.ant-btn {
		height: 52px;
		margin-top: 24px;
		max-width: 170px;
	}
`;

export const Text = styled.div`
	padding-bottom: 10px;
	color: black;
	font-size: 18px;
`;

export const SpinWrapper = styled.div`
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	position: relative;
`;

export const WinnersContainer = styled.div`
	max-height: 332px;
	position: relative;
	overflow: auto;
	@media (max-height: 1300px) {
		height: 255px;
	}
	@media (max-height: 800px) {
		height: 257px;
	}
	@media (max-height: 734px) {
		height: 193px;
	}
	@media (max-height: 683px) {
		height: 173px;
	}
	@media (max-height: 650px) {
		height: 192px;
	}
`;

export const WinnerItem = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
  margin: 0 0 1px 0;
  background-color: #FFF;
	@media screen and (max-height: 670px) {
		height: 47px;
	}
`;

export const DataContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  align-items: left;
  padding: 8px 16px;
`

export const NameAndAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const NameWrapper = styled.div`
  color: #13100F;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
	@media screen and (max-height: 670px) {
		font-size: 10px;
	}
`;

export const PhoneWrapper = styled.div`
  flex-grow: 1;
  text-align: left;
  color: #8E969F;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 100% */
	@media screen and (max-height: 670px) {
		font-size: 10px;
	}
`;

export const AmountWrapper = styled.div`
  color: #13100F;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
	@media screen and (max-height: 670px) {
		font-size: 10px;
	}
`;

export const BottomContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: calc(100% - 293px - 40px - 70px);//100vh - wheel container - button height - top navbar

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: end;
	text-align: center;

	z-index: 1000;

	@media screen and (max-height: 650px) {
    height: calc(100% - 293px - 40px - 70px);
	}
`;

export const TableContainer = styled.div`
  margin: 1px auto auto 0px;
  flex-grow: 1;
	z-index: 99;
	position: relative;
  width: 100%;
  max-width: 480px;
	@media screen and (max-height: 683px) {
		height: calc(100vh - 450px);
	}
`;

export const ButtonWrapper = styled.div`
	height: 49.25px;
	display: flex;
	justify-content: space-between;
	padding: 5px 0;
	margin-top: 400px;
	position: absolute;
	bottom: 0;
	width: 100%;
  background: linear-gradient(270deg, #FFE83A 0%, #FF961B 100%) !important;
	@media screen and (max-height: 650px) {
		height: 30px;
	}
`;

export const ButtonDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 50%;
	cursor: pointer;
  color:  #13100F;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const LoadMoreWrapper = styled.div`
	text-decoration: underline;
	color: #d28a28;
	font-size: 14px;
	font-weight: 100;
	line-height: 17.5px;
	cursor: pointer;
	margin: 10px 0;
`;

export const DividerWrapper = styled.div`
	width: 32.04px;
	margin: 0 auto;
	transform: rotate(90deg);
	display: flex;
	justify-content: center;
	align-items: center;
`;


export const CenterIcon = styled.img.attrs((props) => ({
  id: props.id,
  src: props.src,
}))`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 1000;
	width: 50px;
	height: 50px;

	@media screen and (max-width: 325px) {
		width: 40px;
		height: 40px;
	}
`;
